import React, { useEffect, useState } from "react";
import {AutoComplete, Row, Col, Button, Input, Select} from "antd";
import { useDispatch, useSelector } from "react-redux";
import {addReview, deleteReview, getReviewData, getSpaceData, getUsersData, updateReview, clearReviewDetails} from "./SpaceReviewAction";
import Modal from "antd/es/modal/Modal";
import {Option} from "antd/es/mentions";
import {DeleteOutlined, ExclamationCircleOutlined} from "@ant-design/icons";

const SpaceReview = () => {
    const dispatch = useDispatch();
    const rawSpaceData = useSelector((state) => state.spaceReview?.spaceData?.data?.message || []);
    const rawUserData = useSelector((state) => state.spaceReview?.users || []);
    const reviews = useSelector((state) => state.spaceReview?.reviews?.reviews || []);
    const addReviewState = useSelector((state) => state.spaceReview?.addReview);
    const updateReviewState = useSelector((state) => state.spaceReview?.updateReview);
    const deleteReviewState = useSelector((state) => state.spaceReview?.deleteReview);

    const [spaceData, setSpaceData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [modelVisibility, setModelVisibility] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const [country, setCountry] = useState("LK");
    const [spaceStatus, setSpaceStatus] = useState("ACTIVE");

    const [selectedSpaceObj, setSelectedSpaceObj] = useState({});
    const [selectedEventTypeObj, setSelectedEventTypeObj] = useState({});
    const [selectedUserObj, setSelectedUserObj] = useState({});
    const [errorMessage, setErrorMessage] = useState({"comment":"","rating":"","userId":""});
    const [selectedReviewObj, setSelectedReviewObj] = useState({ "id":"","userId":"", "comment":"","rating":0,"spaceId":"","eventTypeId":"", name: ""});

    useEffect(()=>{
        if(addReviewState?.status === 1 || deleteReviewState?.status === 1 || updateReviewState?.status === 1){
            setModelVisibility(false)
        }
    },[addReviewState, deleteReviewState, updateReviewState])

    useEffect(() => {
        if (rawUserData?.length > 0) {
            setUserData(
                rawUserData?.map((value) => {
                    return { key: value?.id, value: value?.firstName + ' '+ value?.lastName, data: value };
                })
            );
        }
    }, [rawUserData]);

    useEffect(() => {
        if (rawSpaceData?.length > 0) {
            setSpaceData(
                rawSpaceData?.map((value) => {
                    return { key: value?.spaceId, value: value?.spaceName, activity: value?.activity };
                })
            );
        }
    }, [rawSpaceData]);

    const mockVal = (str, repeat = 1) => ({
        value: str.repeat(repeat),
    });

    const selectSpace = (key, value) => {
        setSelectedEventTypeObj({});
        setSelectedSpaceObj(value);
        dispatch(clearReviewDetails());
    };

    const selectEventType = (key, value) => {
        setSelectedEventTypeObj(value);
    };

    const changeCountry = (value) => {
        setCountry(value);
    };

    const changeSpaceStatus = (value) => {
        setSpaceStatus(value);
    };

    const onSpaceNameSearch = (searchText) => {
        dispatch(getSpaceData(1, "20", searchText, country, spaceStatus));
    };

    const selectUser = (key, value) => {
        setSelectedUserObj(value)
        updateReviewObject("userId", value?.data?.id)
        updateReviewObject("name", value?.data?.firstName + ' ' + value?.data?.lastName)
    };

    const onUsersSearch = (searchText) => {
        updateReviewObject("name", searchText)
        // Clear selected user when manually typing to ensure validation works properly
        setSelectedUserObj({})
        dispatch(getUsersData(searchText))
    };

    const submitReviewData = () => {
        if(isValid(selectedSpaceObj?.key)){
            setErrorMessage("Please select space **")
        } else if(isValid(selectedReviewObj?.eventTypeId)){
            setErrorMessage("Please select event **")
        } else if(isValid(selectedReviewObj?.name) && isValid(selectedReviewObj?.rating) && isValid(selectedReviewObj?.comment)){
            setErrorMessage({"userId": "User is required **","rating":"Rating is required **","comment":"Comment is required **"});
        }  else if (isValid(selectedReviewObj?.comment)){
            setErrorMessage({"comment":"Comment is required **"})
        } else if(isValid(selectedReviewObj?.rating)){
            setErrorMessage({"rating":"Rating is required **"})
        } else if(isValid(selectedReviewObj?.name)){
            setErrorMessage({ "userId": "User is required **" })
        } else if(isAdd && (isValid(selectedUserObj?.key) || !selectedUserObj?.data)){
            // Validate that a valid user was actually selected from the dropdown
            setErrorMessage({"userId":"Please select a valid user from the dropdown **"})
        } else {
            if (isAdd) {
                const newData = {"userId": selectedUserObj?.key, "comment": selectedReviewObj?.comment, "rating":selectedReviewObj?.rating, "spaceId":selectedSpaceObj?.key, "eventTypeId":selectedEventTypeObj?.value}
                dispatch(addReview(newData));
            } else {
                const versionHeader = {'If-Match': selectedReviewObj?.version};
                dispatch(updateReview(selectedReviewObj, versionHeader));
            }
        }
    };

    useEffect(()=>{
        setErrorMessage("")
    },[selectedReviewObj])

    const isValid = (value) => {
        return value?.length === 0 || value === undefined || value === null || value ===0
    }

    useEffect(()=>{
        if(selectedSpaceObj?.key && selectedEventTypeObj?.value)
            dispatch(getReviewData(selectedSpaceObj?.key, selectedEventTypeObj?.value))
    },[selectedEventTypeObj, selectedEventTypeObj, addReviewState, deleteReviewState, updateReviewState])

    const openAddModel = () => {
        setIsAdd(true);
        setModelVisibility(true);
        setSelectedReviewObj({ "id":"","userId":"", "comment":"","rating":0,"spaceId":selectedSpaceObj?.key,"eventTypeId":selectedEventTypeObj?.value, name: ""})
    };

    const openEditModel = (value) => {
        setSelectedReviewObj({ "id":value?.id,"version":value?.version,"userId":value?.user?.userId, "comment":value?.comment,"rating":value?.rating,"spaceId":value?.space,"eventTypeId":value?.eventType, name: value?.user?.firstName + ' '+value?.user?.lastName});
        setIsAdd(false);
        setModelVisibility(true);
    };

    const updateReviewObject = (type, newValue) => {
        const tempObj = Object.assign({}, selectedReviewObj, {
            ...selectedReviewObj,
            [type]: newValue
        });
        setSelectedReviewObj(tempObj)
    };

    useEffect(()=>{
        dispatch(clearReviewDetails());
    },[])

    const confirmDeletion = () => {
        return Modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined />,
            content: 'Do you want to delete this?',
            okText: 'Delete',
            cancelText: 'Cancel',
            onOk: () => {
                dispatch(deleteReview(selectedReviewObj?.id))
            }
        });
    }

    const isAddVisible = () => (selectedSpaceObj?.key && selectedEventTypeObj?.value );
    return (
        <>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ padding: "4vh", margin: "3vh", backgroundColor: "#001628", borderRadius: "20px" }}>
                <Col className="gutter-row" span={isAddVisible() ? 5 : 6}>
                    <label style={{ color: "white" }}>Space Status </label>
                    <Select
                        style={{ width: "100%" }}
                        placeholder="Select a event type"
                        onChange={changeSpaceStatus}
                        value={spaceStatus}
                    >
                        <Option value={"INACTIVE"}>Inactive</Option>
                        <Option value={"ACTIVE"}>Active</Option>
                    </Select>
                </Col>

                <Col className="gutter-row" span={isAddVisible() ? 5 : 6}>
                    <label style={{ color: "white" }}>Country </label>
                    <Select
                        style={{ width: "100%" }}
                        placeholder="Select a event type"
                        onChange={changeCountry}
                        value={country}
                    >
                        <Option value={"LK"}>Sri Lanka</Option>
                        {/* <Option value={"SG"}>Singapore</Option> */}
                    </Select>
                </Col>

                <Col className="gutter-row" span={isAddVisible() ? 5 : 6}>
                    <label style={{ color: "white" }}>Space </label>
                    <AutoComplete options={spaceData} style={{ width: "100%" }} onSelect={selectSpace} value={selectedSpaceObj?.name}  onSearch={onSpaceNameSearch} placeholder="Space Name or Id" />
                </Col>

                <Col className="gutter-row" span={isAddVisible() ? 5 : 6}>
                    <label style={{ color: "white" }}>Activity Type </label>
                    <Select
                        style={{ width: "100%" }}
                        placeholder="Select a event type"
                        onChange={selectEventType}
                        value={selectedEventTypeObj?.value}
                    >
                        {selectedSpaceObj?.activity?.map(value=> <Option value={value?.id}>{value?.name}</Option>)}
                    </Select>
                </Col>
                {isAddVisible() &&(<Col className="gutter-row" span={4}>
                    <br/>
                    <Button type="primary" style={{ width: "60%"}}
                            onClick={() => {
                                openAddModel();
                            }}
                    >
                        Add Review
                    </Button>
                    <Button type="primary" style={{width: "35%",marginLeft:8}}
                            onClick={() => {
                                dispatch(clearReviewDetails());
                                setSelectedEventTypeObj({}); 
                                setSelectedSpaceObj({name:null}); 
                            }}
                    >
                       Clear
                    </Button>
                </Col>)}
            </Row>

            <div style={{ width: "100%", height: "67vh", overflow: "auto" }}>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ margin: "20px" }}>
                    {[].concat(reviews)?.map((value) => {
                        return (
                            <Col className="gutter-row" span={8} style={{ marginBottom: "5vh" }}>
                                <div style={{ height: "100%", width: "100%", backgroundColor: "white", borderRadius: "20px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", cursor: "pointer" }} onClick={() => openEditModel(value)}>
                                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ margin: "20px" }}>
                                        <Col className="gutter-row" span={8}>
                                            <img src={value?.user?.profilePhoto||'https://cdn.iconscout.com/icon/free/png-512/laptop-user-1-1179329.png'} style={{ width: "10vh", height: "10vh", marginLeft: "1vh", marginTop: "1vh", borderRadius: "50%" }} />
                                        </Col>
                                        <Col className="gutter-row" span={16} style={{ marginTop: "20px" }}>
                                            <h2 style={{ fontWeight: "900" }}>{value?.user?.firstName} {value?.user?.lastName}</h2>
                                            <hr />
                                            {value?.user?.userId && (<p>User Id: {value?.user?.userId}</p>)}
                                            {value?.user?.username && (<p>User Name: {value?.user?.username}</p>)}
                                        </Col>
                                    </Row>
                                    <div style={{ backgroundColor: "#f5f5f5", padding: "5vh", margin: "1vh", borderRadius: "1vh" }}>
                                        <p>{value?.comment}</p>
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            </div>

            <Modal
                visible={modelVisibility}
                title={`${isAdd ? "Add" : "Edit"} Review`}
                style={{ borderRadius: "50px" }}
                onOk={submitReviewData}
                onCancel={() => setModelVisibility(false)}
                footer={isAdd? [
                    <Button key="submit" type="primary" onClick={submitReviewData}>
                        {`${isAdd ? "Submit" : "Update"}`}
                    </Button>,
                ]: [
                    <Button key="back" onClick={confirmDeletion}>
                        <DeleteOutlined /> Delete
                    </Button>,
                    <Button key="submit" type="primary" onClick={submitReviewData}>
                        {`${isAdd ? "Submit" : "Update"}`}
                    </Button>,
                ]}
            >
                <label>Select user </label>
                <br />
                <AutoComplete options={userData} style={{ width: 250 }} onSelect={selectUser} onSearch={onUsersSearch} placeholder="User Details" disabled={isAdd ?false :true} value={selectedReviewObj?.name} />
                <br /><sub style={{color:"red"}}>{errorMessage?.userId}</sub>
                <br />
                <label>Rating </label>
                <Input placeholder="Enter rating" type="number" value={selectedReviewObj?.rating || ""} onChange={(newValue) => updateReviewObject("rating", Number(newValue.target.value) <= 5 ? Number(newValue.target.value) > 0 ? Number(newValue.target.value) : 1 : 5)}   />
                <sub style={{color:"red"}}>{errorMessage?.rating}</sub>
                <br />
                <br />
                <label>Comment </label>
                <Input placeholder="Enter comment..." value={selectedReviewObj?.comment || ""} onChange={(newValue) => updateReviewObject("comment", newValue.target.value)}/>
                <sub style={{color:"red"}}>{errorMessage?.comment}</sub>
            </Modal>
        </>
    );
};

export default SpaceReview;
